import React from 'react';

const BADGE_TTL_DAYS = 7;

export function FirstBookingBadge({ userId }) {
  const storageKey = `firstBookingCelebrated_${userId}`;
  const celebratedAt = localStorage.getItem(`${storageKey}_at`);
  if (!celebratedAt) return null;

  const ageMs = Date.now() - Number(celebratedAt);
  const ageDays = ageMs / (1000 * 60 * 60 * 24);
  if (ageDays > BADGE_TTL_DAYS) return null;

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '2px 8px',
      borderRadius: '9999px',
      fontSize: '12px',
      fontWeight: 500,
      background: 'var(--color-accent, #8b3a2a)',
      color: 'var(--color-paper, #faf7f2)',
      opacity: 0.9,
    }}>
      <span>✦</span> First booking
    </span>
  );
}
